import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';
import isEqual from 'lodash.isequal';
import { BudgetResultCard } from './BudgetResultCard';
import { BudgetActionCreators } from '../../../actions';
import { RouteUrls } from '../../../configs/routeUrls';

class BudgetResultContainer extends Component {
	componentDidMount() {
		const { id } = this.props.match.params;
		if (id) {
			this.props.getBudgetResults(id);
		}
	}

	componentDidUpdate(prevProps) {
		if (!isEqual(prevProps.match.params, this.props.match.params) && this.props.match.params.id) {
			const { id } = this.props.match.params;
			this.props.getBudgetResult(id);
		}
	}
	render() {
		const { budgetResult, goTo, isBudgetResultLoading,isOnlyOneOffice, onCancel } = this.props;

		return (
			<BudgetResultCard
				{...budgetResult}
				goTo={goTo}
				isBudgetResultLoading={isBudgetResultLoading}
				isOnlyOneOffice={isOnlyOneOffice}
				onCancel={onCancel}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isBudgetResultLoading: state.budget.isBudgetResultLoading,
		budgetResult: state.budget.results,
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators(BudgetActionCreators, dispatch),
		goTo: (id) => dispatch(push(`${RouteUrls.Budget.projectTasks.preview}/${id}`)),
		onCancel: () => dispatch(goBack())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetResultContainer);
